const reducer = (obj, arr) => {
  const eslintCompatibleObject = {
    ...obj
  };
  const [eslintCompatibleElement0, eslintCompatibleElement1] = arr;
  eslintCompatibleObject[eslintCompatibleElement0] = eslintCompatibleElement1;
  return eslintCompatibleObject;
};
function parseIterator(data) {
  return [...data].reduce(reducer, {});
}
export default parseIterator;
//# sourceMappingURL=parseIterator.js.map